import React from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { useEffect } from "react";
import Spinner from "../../../component/loadingbar/Spinner";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const AddReferral = () => {
  const { id } = useParams();
  const { token } = config;
  const navigate = useNavigate();
  //--------------------------------- manage state ---------------------------------
  const [loading, setLoading] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [courses, setCourses] = useState("");
  const [formData, setFormData] = useState({
    course: null,
    coupon: "",
    email: null,
    discount: "",
  });

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleEmailChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      email: selectedOption,
    }));
  };
  const handleCourseChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      course: selectedOption,
    }));
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setFormData({
      course: null,
      coupon: formData.coupon && formData.coupon,
      email: null,
      discount: "",
    });

    if (id) {
      navigate("/viewemployees");
    }
  };

  //--------------------------------- coupon generation | get / read leadData ---------------------------------
  const generateReferralCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";

    let referralCode = "DV";
    referralCode += characters[Math.floor(Math.random() * characters.length)]; // Add a random character
    referralCode += characters[Math.floor(Math.random() * characters.length)]; // Add a random character
    referralCode += characters[Math.floor(Math.random() * characters.length)]; // Add a random character
    referralCode += characters[Math.floor(Math.random() * characters.length)]; // Add a random character
    referralCode += numbers[Math.floor(Math.random() * numbers.length)]; // Add a random number
    referralCode += numbers[Math.floor(Math.random() * numbers.length)]; // Add a random number

    setFormData((prevData) => ({
      ...prevData,
      coupon: referralCode,
    }));
  };

  const getLeadData = () => {
    setLoading(true);
    fetch(`${config.host_url}lead-profile/my-lead`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          const emailOptions = data.data.map((lead) => ({
            value: lead.email_1,
            label:
              lead.first_name_of_lead +
              " " +
              lead.last_name_of_lead +
              " - " +
              lead.email_1,
            id: lead.lead_profile_id,
          }));
          setLeadData(emailOptions);
        } else if (data.status === 401) {
          console.error("Invalid token");
        } else {
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching lead profile data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getCourses = () => {
    setLoading(true);
    fetch(`${config.host_url}sales/mycourses`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          const courseOptions = data.data.map((course) => ({
            value: course.course_id,
            label: course.course_name,
            id: course.course_id,
          }));
          setCourses(courseOptions);
        } else if (data.status === 401) {
          console.error("Invalid token");
        } else {
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching courses data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCourses();
    getLeadData();
    generateReferralCode();
  }, [token]);

  // ---------------------------------------------- create / add / update coupon -------------------------------------------------------c--u
  // Function to create a new coupon
  const addReferralBtn = async () => {
    try {
      if (
        !formData?.course?.value ||
        !formData?.coupon?.trim() ||
        !formData?.discount?.trim() ||
        !formData?.email?.value
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(`${config.host_url}sales-coupon`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          courseid: formData.course.value,
          coupon: formData.coupon,
          email: formData.email.value,
          discount: formData.discount,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Coupon created successfully
            triggerNotification(
              "success",
              `${
                id
                  ? "Coupon updated successfully."
                  : "Coupon created successfully."
              }`
            );
            navigate("/viewrefferals");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating Coupon:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the Coupon."
      );
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Token Coupon" subpath={["Add Token Coupon"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Token Coupon</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* Email Address */}
                <div className="form-floating form-floating-outline mb-4 ">
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={courses}
                    value={formData.course}
                    placeholder="Select Course"
                    onChange={handleCourseChange}
                  />
                </div>

                {/* Email Address */}
                <div className="form-floating form-floating-outline mb-4 ">
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={leadData}
                    value={formData.email}
                    placeholder="Select Email Address"
                    onChange={handleEmailChange}
                  />
                </div>

                {/* Discount */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="number"
                    min={1}
                    max={1}
                    className="form-control"
                    name="discount"
                    id="discount"
                    placeholder="Discount"
                    value={formData.discount}
                    onChange={handleChange}
                  />
                  <label htmlFor="discount">Discount</label>
                </div>

                {/* Coupon Code */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="coupon"
                    id="coupon"
                    placeholder="Coupon Code"
                    value={formData.coupon}
                    disabled
                  />
                  <label htmlFor="coupon">Coupon Code</label>
                </div>

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    {/* clear/ calcel */}
                    <button
                      type="button"
                      className="btn  btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn ml-2  btn-primary"
                      onClick={addReferralBtn}
                    >
                      {id ? "Update" : "Submit"}
                    </button>
                    {/* clear | cancel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={generateReferralCode}
                    >
                      Re-Generate
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddReferral;
